import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from '../shared/auth-service/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
  loginForm: FormGroup = new FormGroup ({
    email: new FormControl(''),
    password: new FormControl(''),
  });

  constructor(
    private authService: AuthService
  ) {}

  onSubmit() {
    this.authService.login(this.loginForm.value.email, this.loginForm.value.password);
  }

}
